export const ListQueryKey = 'boatMems';
export const DetailQueryKey = 'boatMem';

export const Urls = {
  selectUrl: '/boatMem/list',
  updateUrl: '/boatMem/update',
  deleteUrl: '/boatMem/delete',
  createUrl: '/boatMem/create',
  detailUrl: '/boatMem/detail',
};
